import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_ZENDESK } from './constants';
import { verifyZendesk } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { ZENDESK_VERIFY } from 'common/strings';
import localStorageTemplates from 'common/local-storage-templates';
import { readToken } from 'utils/readToken';

export function* saveZendeskCode({ payload, metadata }) {
  const token = readToken();
  const { projectName } = metadata;
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/integration/zendesk',
      projectName,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });

    yield put(verifyZendesk.success());
    triggerNotification({
      title: ZENDESK_VERIFY.ALERTS.INTEGRATE_ZENDESK_SUCCESS,
      type: NOTIFICATION.TYPE.SUCCESS,
    });
  } catch (error) {
    const errorMessage = convertErrorMsg(error);

    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifyZendesk.error(errorMessage));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* zendeskVerify() {
  yield takeLatest(VERIFY_ZENDESK.START, saveZendeskCode);
}
